// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0bca5d239ed42afe7666","691":"a89c953b7ac545e37cb9"}[chunkId] + ".js";
};